/* eslint-disable no-nested-ternary */
import React, { Fragment, useContext, useEffect, useState } from 'react';
import { NavBar, List, Popup, Button } from 'antd-mobile';
import { CloseOutline } from 'antd-mobile-icons';
import groupBy from 'lodash/groupBy';
import styled from 'styled-components';
import InputComponent from './Input';
import {
	calculateParametersFormula,
	displayParameterValue,
	getLinkedParametersData,
	getTrackingParameters,
	isEnabledParameter
} from '../utils/helpers';
import UserSelfContext from '../utils/self-context';

const ParamsWrapper = styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	flex-flow: column;
`;
const ContentWrapper = styled.div`
	flex: 1;
	min-height: 0;
	overflow: auto;
	width: 100%;
	background: #f0f2f5;
`;

const Overview = styled.div`
	padding: 12px 0px;
`;

const Nav = styled(NavBar)`
	background: #fff;
	display: flex;
	border-bottom: solid 1px var(--adm-color-border);
`;

const Save = styled(Button)`
	font-size: 17px;
`;

function AircraftPopup(props) {
	const {
		visible,
		saving,
		onClose,
		aircraft = {},
		onSave
	} = props;
	const { userSelf } = useContext(UserSelfContext);

	const TRACKING_PARAMETERS = getTrackingParameters(userSelf);
	const groupedParametersByCategory = groupBy(TRACKING_PARAMETERS, 'category');

	const [values, setValues] = useState({
		...aircraft
	});

	function onSaveClick() {
		onSave(values);
	}

	useEffect(() => {
		setValues({
			...values,
			...aircraft
		});
	}, [aircraft, visible]);

	function getGetFieldDiff(field) {
		const currentValue = aircraft[field.key];
		const fieldValue = values[field.key];

		if (fieldValue && currentValue !== fieldValue) {
			return Number(fieldValue) - Number(currentValue);
		}

		return 0;
	}

	function getDiffText(field) {
		const diff = getGetFieldDiff(field);
		if (diff) {
			return `${diff > 0 ? '+' : ''}${displayParameterValue(diff, field)}`;
		}

		return null;
	}

	async function onValueChange(data, param) {
		const linkedParametersData = getLinkedParametersData({
			trackingParameters: TRACKING_PARAMETERS,
			currentValues: values,
			newValues: { [param.key]: data[param.key] }
		});
		const calculatedFormulaData = calculateParametersFormula({
			data: { ...values, ...data, ...linkedParametersData },
			trackingParameters: TRACKING_PARAMETERS
		});

		const newData = { ...data, ...linkedParametersData, ...calculatedFormulaData };

		setValues({ ...values, ...newData });
	}

	return (
		<Popup
			position='right'
			visible={visible}
			bodyStyle={{ width: '100%' }}
			onClose={onClose}
		>
			<ParamsWrapper>
				<Nav
					backArrow={<CloseOutline />}
					onBack={onClose}
					back={''}
					right={<Save fill='none' loading={saving} onClick={onSaveClick}>Save</Save>}
				>
					Update status
				</Nav>
				<ContentWrapper>
					<Overview>
						<List>
							{Object.keys(groupedParametersByCategory)
								.filter(key => groupedParametersByCategory[key].some(param => isEnabledParameter(aircraft.enabled_parameters, param.key)))
								.map((key) => {
									return <Fragment key={key}>
										{groupedParametersByCategory[key].map((param) => {
											if (isEnabledParameter(aircraft.enabled_parameters, param.key)) {
												return <InputComponent
													onSave={data => onValueChange(data, param)}
													key={param.key}
													min={0}
													disabled={param.is_calculated}
													dataKey={`${param.key}`}
													title={param.name}
													description={getDiffText(param)}
													digits={param.precision}
													type={param.type === 'hours' ? 'hours' : 'stepper'}
													initialValue={values[`${param.key}`] || 0}
												/>;
											}

											return null;
										})}
									</Fragment>;
								})}
						</List>
					</Overview>
				</ContentWrapper>
			</ParamsWrapper>
		</Popup>
	);
}

export default AircraftPopup;
